///////////////////////////////////////////////////////////////////////////////
// preload, must come first
import "js/player/preload.backbone";
///////////////////////////////////////////////////////////////////////////////

import React from "react";

// preload: shared
import "js/preload";

// preload: player
import "js/player/player";
import "js/player/playerView";

import player from "js/player/player";

export default class Player extends React.Component {
    constructor(props) {
        super(props);
        this.el = React.createRef();
    }

    async componentDidMount() {
        player.initialize(this.el.current);
    }

    render() {
        return (
            <div
                id="react-player"
                style={{ display: "contents" }}
                ref={this.el}
            />
        );
    }
}
